import { styledOmitCustomProps } from '@braskai/ui-kit';

import { Box, BoxProps, styled, Theme } from '@mui/material';

type TContainerProps = {
  $isBusiness: boolean;
  $isCreatorPro: boolean;
  $isCurrentPlan: boolean;
  $isDisabled: boolean;
  $isEnterprise: boolean;
} & BoxProps;

const getBorder = (
  isEnterprise: boolean,
  isCreatorPro: boolean,
  isDisabled: boolean,
  isCurrentPlan: boolean,
  theme: Theme,
) => {
  const defaultStyle = `1px solid ${theme.palette.grey[200]}`;

  if (isCurrentPlan || isDisabled) return defaultStyle;

  if (isEnterprise) return 'none';

  if (isCreatorPro) return `2px solid ${theme.palette.primary[600]}`;

  return defaultStyle;
};

const getBackgroundColor = (
  isEnterprise: boolean,
  isBusiness: boolean,
  isDisabled: boolean,
  isCurrentPlan: boolean,
  theme: Theme,
) => {
  const defaultStyle = 'transparent';

  if (isCurrentPlan) return theme.palette.grey[50];

  if (isDisabled) return defaultStyle;

  if (isEnterprise) return '#050560';

  if (isBusiness) return '#F5F5FF';

  return defaultStyle;
};

const getColor = (isEnterprise: boolean, isDisabled: boolean, isCurrentPlan: boolean) => {
  const defaultStyle = 'inherit';

  if (isCurrentPlan || isDisabled) return defaultStyle;

  if (isEnterprise) return 'common.white';

  return defaultStyle;
};

export const SContainer = styled(
  Box,
  styledOmitCustomProps,
)<TContainerProps>(({ $isDisabled, $isEnterprise, $isCreatorPro, $isBusiness, $isCurrentPlan, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '100%',
  background: getBackgroundColor($isEnterprise, $isBusiness, $isDisabled, $isCurrentPlan, theme),
  color: getColor($isEnterprise, $isDisabled, $isCurrentPlan),
  border: getBorder($isEnterprise, $isCreatorPro, $isDisabled, $isCurrentPlan, theme),
  borderRadius: 16,
  padding: 20,
  position: 'relative',
}));
